<template>
	<div class="sf-datatable-wrapper">
		<div class="sf-datatable-container">
			<div class="sf-actions">
				<div className="sf-actions_left">
					<!--저장-->
					<sf-button line v-if="isButton_(scrId, 'CU')" icon="file" :onClick="saveAction">{{ getMessage_('SWCC000327') }}</sf-button>
					<!--삭제-->
					<!-- <sf-button line v-if="isButton_(scrId, 'CD')" icon="trash" color="error" :onClick="deleteAction">{{
						getButtonMsg_(scrId, 'CD')
					}}</sf-button> -->
				</div>
			</div>
			<div class="sf-card__header mt-3">
				<div class="d-flex align-items-end">
					<span class="title"><i class="sf-icon icon-sf-caret-right" />{{ getMessage_('QWCC001364') }}</span>
				</div>
			</div>

			<div class="sf-table">
				<table class="qms-table">
					<tbody>
						<tr>
							<!-- 캠페인번호 -->
							<th class="col-1">* {{ getMessage_('QWCC001024') }}</th>
							<td class="col-1">
								<el-input :value="campaignInfo.cmpnNo" @input="val => onChangeSelect(val, 'cmpnNo')" readonly />
							</td>
							<!-- 캠페인명 -->
							<th class="col-1">{{ getMessage_('QWCC001007') }}</th>
							<td class="col-1"><el-input :value="campaignInfo.cmpnNm" @input="val => onChangeSelect(val, 'cmpnNm')" readonly /></td>
							<!--협력사-->
							<th class="col-1">{{ getMessage_('QWCC000958') }}</th>
							<td class="col-1"><el-input :value="campaignInfo.cpnyCd" readonly /></td>
							<!-- <td class="col-1">
								<div class="sf-input-group-wrapper">
									<el-col>
										<div class="search-option-wrapper__normal">
											<el-input v-model="menuCmpnCd" class="inputWithIcon" @keyup.native.delete="onMenuCmpnCdInPutKeyDown()"></el-input>
											<i class="icon-sf-search search-icon" @click="() => onCmpnPopup()"></i>
										</div>
									</el-col>
								</div>
							</td> -->
							<!--협력사명-->
							<th class="col-1">{{ getMessage_('QWCC001342') }}</th>
							<td class="col-1"><el-input :value="campaignInfo.cpnyNm" readonly /></td>
							<!--실납품사-->
							<th class="col-1">{{ getMessage_('QWCC001924') }}</th>
							<td class="col-1"><el-input :value="campaignInfo.dlvgNm" readonly /></td>
						</tr>
						<tr>
							<!--귀책율(HTWO)-->
							<th class="col-1">* {{ getMessage_('QWCC001367') }}</th>
							<td class="col-1">
								<el-input :value="campaignInfo.atblRt1" maxlength="4" @input="val => onChangeSelect(val, 'atblRt1')" />
							</td>
							<!--귀책율(HMC) -->
							<th class="col-1">{{ getMessage_('QWCC001368') }}</th>
							<td class="col-1">
								<el-input :value="campaignInfo.atblRt2" maxlength="4" @input="val => onChangeSelect(val, 'atblRt2')" />
							</td>
							<!--귀책율(협력사)-->
							<th class="col-1">{{ getMessage_('QWCC001369') }}</th>
							<td class="col-1">
								<el-input :value="campaignInfo.atblRt3" maxlength="4" @input="val => onChangeSelect(val, 'atblRt3')" />
							</td>
							<!--귀책율(OEM)-->
							<th class="col-1">* {{ getMessage_('QWCC001370') }}</th>
							<td class="col-1">
								<el-input :value="campaignInfo.atblRt4" maxlength="4" @input="val => onChangeSelect(val, 'atblRt4')" />
							</td>
							<th class="col-1"></th>
							<td class="col-1"></td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	</div>
</template>

<script>
import * as yup from 'yup';
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@mqy/qlty/Campaign/store/helpers';
import { convertNvl } from '@/qmsUtils/'; //공통함수 import
import moment from 'moment';
export default {
	props: {
		scrId: { type: String, default: '' },
		sendParam1: { type: Object } //딜러점
	},
	components: {},
	data() {
		return {
			// menuCmpnCd: '', //딜러점 코드
			// menuCmpnNm: '', //딜러점
			// manuCmpn: {
			// 	cpnyCd: '',
			// 	cpnyNm: '',
			// 	cpnyScn: '10'
			// }
		};
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		insVali() {
			return yup.object().shape({
				atblRt4: yup // 귀책율(OEM)
					.number()
					.typeError(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001370')]))
					.required(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001370')])),
				atblRt3: yup // 귀책율(협력사)
					.number()
					.typeError(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001369')]))
					.required(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001369')])),
				atblRt2: yup // 귀책율(HMC)
					.number()
					.typeError(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001368')]))
					.required(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001368')])),
				atblRt1: yup // 귀책율(HTWO)
					.number()
					.typeError(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001367')]))
					.required(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001367')]))
			});
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		onChangeSelect(value, key) {
			//숫자 길이 2자리, 소수점 1자리로 입력 제한
			if (key === 'atblRt1' || key === 'atblRt2' || key === 'atblRt3' || key === 'atblRt4') {
				value = value.replace(/[^\.0-9]/g, '');
				const arr = value.toString().split('.');
				if (arr.length > 2) {
					return;
				}
				if (arr.length == 1) {
					if (value.length > 2) {
						value = value.slice(0, 2);
					}
				}
				if (arr.length == 2) {
					if (arr[1].length > 1) {
						arr[1] = arr[1].slice(0, 1);
					}
					if (arr[0].length > 2) {
						arr[0] = arr[0].slice(0, 2);
					}
					arr[1] = '.' + arr[1];
					value = arr.reduce((a, b) => a + b);
				}

				this.setCampaignInfo_({ key, value });
			}
		},
		// onCmpnPopup(param) {
		// 	//딜러점 팝업
		// 	this.manuCmpn.cpnyCd = this.menuCmpnCd;
		// 	this.$emit('OpenCmpnPopup', this.manuCmpn);
		// },
		// onMenuCmpnCdInPutKeyDown() {
		// 	this.menuCmpnCd = '';
		// 	this.menuCmpnNm = '';
		// },
		saveAction() {
			try {
				this.setCampaignInfo_({ key: 'atblCpnyCd', value: convertNvl(this.menuCmpnCd, '') });

				const saveParams = this.campaignInfo;
				const popupParams = {
					menuCmpnNm: this.menuCmpnNm
				};
				const total = Number(saveParams.atblRt1) + Number(saveParams.atblRt2) + Number(saveParams.atblRt3) + Number(saveParams.atblRt4);

				//벨리데이션 체크
				this.insVali.validateSync(saveParams);

				if (total !== 100) {
					//귀책율들의 합은 100이여야 합니다.
					throw new Error(this.getMessage_('QWCC001396'));
				} else {
					//컨펌창
					this.$sf_showMessage({
						type: 'confirm',
						icon: 'confirm',
						title: this.getMessage_('SWCC000501'), //저장하시겠습니까?
						buttons: [{ title: this.getMessage_('SWCC000278'), clickFn: this.save }] //저장
					});
				}
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error.message });
			} finally {
				this.$sf_toggleLoading(false);
			}
		},
		async save() {
			this.$sf_toggleLoading(true);
			const saveParams = this.campaignInfo;
			const params = { saveParams: saveParams };
			await this.savecampaignInfo_(params)
				.then(response => {
					if (response.header.message != undefined && response.header.message != null) {
						this.$sf_toast({
							type: response.header.code === 0 ? 'ok' : 'error',
							message: this.getMessage_(response.header.messageCd)
						});
					}
				})
				.catch(error => {
					this.$sf_toast({
						type: 'error',
						message: error.message
					});
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
			const campaignInfo = this.campaignInfo;
			await this.getCampaignInfo_(campaignInfo);
			this.$sf_toggleLoading(false);
		},
		deleteAction() {
			try {
				const deleteParams = this.campaignInfo;

				//벨리데이션 체크
				this.insVali.validateSync(deleteParams);

				//컨펌창
				this.$sf_showMessage({
					type: 'confirm',
					icon: 'confirm',
					title: this.getMessage_('SWCC000108'), //삭제하시겠습니까?
					buttons: [{ title: this.getMessage_('SWCC000107'), clickFn: this.delete }] //삭제
				});
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error.message });
			} finally {
				this.$sf_toggleLoading(false);
			}
		},
		async delete() {
			this.$sf_toggleLoading(true);
			try {
				const deleteParams = this.campaignInfo;
				const cmpnNo = this.campaignInfo.cmpnNo;

				const params = { cmpnNo: cmpnNo, deleteParams: deleteParams };

				const { code, messageCd } = await this.deletecampaignInfo_(params);

				if (code === 0 || code === 3) {
					this.$sf_toast({
						type: code === 0 ? 'ok' : 'error',
						message: this.getMessage_(messageCd)
					});
					code === 0 && this.$emit('Refresh');
				}
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error.message });
			} finally {
				this.$emit('close');
				this.$sf_toggleLoading(false);
			}
		}
	},
	created() {
		// this.menuCmpnCd = this.campaignInfo.atblCpnyCd; //딜러점코드
		// this.menuCmpnNm = this.campaignInfo.atblCpnyNm; //딜러점명
	},
	watch: {
		// sendParam1(newValue, oldValue) {
		// 	this.menuCmpnCd = this.sendParam1.cpnyCd;
		// 	this.menuCmpnNm = this.sendParam1.cpnyNm;
		// 	this.manuCmpn.cpnyCd = this.menuCmpnCd;
		// 	this.manuCmpn.cpnyNm = this.menuCmpnNm;
		// }
	}
};
</script>
<style>
.sf-input-group-wrapper__label {
	color: aqua;
}
.search-option-wrapper__normal {
	position: relative;
}
.search-icon {
	color: var(--color-default);
	font-size: 1.5rem;
	position: absolute;
	right: 0;
	cursor: pointer;
	top: -3px;
}
</style>
